import { Helmet } from "react-helmet-async";
import Hero from "../components/Hero";
import EditorialMarquee from "../components/EditorialMarquee";
import FeaturedClasses from "../components/FeaturedClasses";
import NewsletterPopup from "../components/NewsletterPopup";

export default function Home() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://salumitucson.com/#org",
    name: "Salumi Tucson",
    description:
      "Tucson-based culinary experiences — intimate cooking classes, pasta workshops, cocktail ateliers, charcuterie studios, seasonal dinners, and private gatherings.",
    address: { "@type": "PostalAddress", addressLocality: "Tucson", addressRegion: "AZ", addressCountry: "US" },
    sameAs: ["https://www.instagram.com/salumitucson/"],
    priceRange: "$$",
    servesCuisine: "Mediterranean, Italian",
  };
  return (
    <>
      <Helmet>
        <title>Salumi Tucson — Hands-on Culinary Experiences in Tucson, Arizona</title>
        <meta
          name="description"
          content="Intimate cooking classes, pasta workshops, cocktail ateliers, charcuterie studios, seasonal dinners and private culinary gatherings in Tucson, Arizona. Book a private experience or explore upcoming classes."
        />
        <meta name="keywords" content="cooking classes Tucson, private cooking classes Tucson, pasta making class Tucson, Tucson culinary experiences, Tucson food events, cocktail workshop Tucson, charcuterie workshop Tucson, Tucson date night ideas, girls night Tucson, culinary workshops Arizona, seasonal cooking classes Tucson" />
        <link rel="canonical" href="https://salumitucson.com/" />
        <meta property="og:title" content="Salumi Tucson — Hands-on Culinary Experiences" />
        <meta property="og:description" content="Cinematic cooking classes, cocktails, fresh pasta and private gatherings in Tucson, Arizona." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://salumitucson.com/" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
      <Hero />
      <EditorialMarquee />
      <FeaturedClasses />
      <NewsletterPopup />
    </>
  );
}
